export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'read',
    subject: 'recruiter',
  },
  {
    action: 'read',
    subject: 'influencer',
  },
]

export const _ = undefined
